import { SvgIcon } from "../svg-icon";

type Props = {
	size?: number;
	className?: string;
};

export const Spinner = ({ size, className = "text-interactive-primary" }: Props) => (
	<SvgIcon className={className} imageSrc="SPINNER" height={size} />
);
